import { local } from './storage';
import AuthService, { TokenStorage } from './AuthenticationServiceInstaller';
import {
  ApigeeAuthAdapter,
  FirebaseAuthAdapter,
  HybridAuthAdapter,
} from './AuthenticationServiceInstaller/authAdapters';
import config from '../config';

const apigeeAdapter = new ApigeeAuthAdapter({
  baseUrl: config.apigee.auth.url,
  clientId: config.apigee.auth.clientId,
});

const firebaseAdapter = new FirebaseAuthAdapter();

const hybridAdapter = new HybridAuthAdapter(firebaseAdapter, apigeeAdapter);
const tokensStorage = new TokenStorage(local, 'pge-installer-token');

export default new AuthService(hybridAdapter, tokensStorage);
